import PropTypes from 'prop-types';
import React from 'react';

import FailureBody from './FailureBody';

const propTypes = {
  data: PropTypes.array,
};

const FailureResults = ({ data }) => {
  if (!data) {
    return <div className='font-semibold text-center p-4'>Please select a site in configure section.</div>;
  }

  if (!data.length) {
    return <div className='font-semibold text-center p-4'>No results to show.</div>;
  }

  return <FailureBody data={data} />;
}

FailureResults.propTypes = propTypes;

export default FailureResults;
